module.exports = __webpack_public_path__ + "static/media/image-16.e38ea475.jpg";